import React, { useMemo } from 'react';
import CommonVisualInsights from '../CommonVisualInsights';
import { othersCohorts } from "./OthersDataPoints";

const OthersVisualInsights = ({ chartData, loading, overallTotals: injectedTotals }) => {
    const overallTotals = injectedTotals || {
        total_normal: chartData?.overallTotals?.total_non_anaemic || chartData?.overallTotals?.total_normal || 0,
        total_mild: chartData?.overallTotals?.total_mild || 0,
        total_moderate: chartData?.overallTotals?.total_moderate || 0,
        total_severe: chartData?.overallTotals?.total_severe || 0
    };

    // Cohort Series for Stacked Column Chart
    const cohortSeriesData = useMemo(() => {
        let nonData = [], mildData = [], modData = [], sevData = [];
        const categories = othersCohorts.map(c => c.label);

        if (chartData?.groupBreakdown) {
            othersCohorts.forEach((c) => {
                const groupData = chartData.groupBreakdown[c.key] || { non_anaemic: 0, mild: 0, moderate: 0, severe: 0 };
                nonData.push(groupData.non_anaemic || 0);
                mildData.push(groupData.mild || 0);
                modData.push(groupData.moderate || 0);
                sevData.push(groupData.severe || 0);
            });
        }
        return { categories, nonData, mildData, modData, sevData };
    }, [chartData]);

    // Timeline Trend for Line Area Chart
    const timelineSeriesData = useMemo(() => {
        let dates = [], nonList = [], mildList = [], modList = [], sevList = [];
        if (chartData?.timelineTrend) {
            chartData.timelineTrend.forEach((t) => {
                dates.push(t.date);
                nonList.push(t.total_non_anaemic || 0);
                mildList.push(t.total_mild || 0);
                modList.push(t.total_moderate || 0);
                sevList.push(t.total_severe || 0);
            });
        }
        return { dates, nonList, mildList, modList, sevList };
    }, [chartData]);

    // Aggregate District-wise risk rankings
    const districtRiskData = useMemo(() => {
        let categories = [], nonSeries = [], mildSeries = [], moderateSeries = [], severeSeries = [];
        if (chartData?.districtLeaderboard) {
            chartData.districtLeaderboard.forEach((d) => {
                categories.push(d.district_name);
                nonSeries.push(d.total_non_anaemic || 0);
                mildSeries.push(d.total_mild || 0);
                moderateSeries.push(d.total_moderate || 0);
                severeSeries.push(d.total_severe || 0);
            });
        }
        return { categories, nonSeries, mildSeries, moderateSeries, severeSeries };
    }, [chartData]);

    return (
        <CommonVisualInsights
            loading={loading}
            overallTotals={overallTotals}
            cohortSeriesData={cohortSeriesData}
            timelineSeriesData={timelineSeriesData}
            districtRiskData={districtRiskData}
        />
    );
};

export default OthersVisualInsights;
